import React from 'react';

const SkeletonTable = () => {
  return (
    <div className="w-full space-y-4">
      {/* Search bar skeleton */}
      <div className="flex justify-between items-center">
        <div className="relative w-full max-w-md">
          <div className="h-10 w-full bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
        </div>
        <div className="h-10 w-24 bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
      </div>
      
      {/* Table skeleton */}
      <div className="w-full border rounded-md">
        {/* Header */}
        <div className="flex items-center border-b p-4">
          <div className="w-1/6 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
          <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
          <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
          <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse" />
        </div>
        
        {/* Rows */}
        {[1, 2, 3, 4, 5].map((row) => (
          <div key={row} className="flex items-center border-b p-4">
            <div className="w-1/6 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
            <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
            <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse mr-2" />
            <div className="w-1/4 h-4 bg-gray-100 dark:bg-gray-800 rounded animate-pulse" />
          </div>
        ))}
      </div>
      
      {/* Pagination skeleton */}
      <div className="flex justify-end items-center gap-2">
        <div className="h-10 w-24 bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
        <div className="h-10 w-24 bg-gray-100 dark:bg-gray-800 rounded-md animate-pulse" />
      </div>
    </div>
  );
};

export default SkeletonTable;